import React, { useState, useEffect } from 'react';
import { getBlogCategories, getBlogPosts, getCoverImageUrl, downloadBlogFile, formatFileSize, getFileIcon } from './api/blogApi';

function formatDate(dateStr) {
  return new Date(dateStr).toLocaleDateString('fa-IR');
}

export const Blog = () => {
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState('');
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [downloadingId, setDownloadingId] = useState(null);

  const [modal, setModal] = useState({ show: false, message: '' });

  useEffect(() => {
    async function loadCategories() {
      const result = await getBlogCategories();
      if (result.success) setCategories(result.data.categories);
    }
    loadCategories();
  }, []);

  useEffect(() => {
    async function loadPosts() {
      setLoading(true);
      const result = await getBlogPosts(selectedCategory, page);
      setLoading(false);
      if (result.success) {
        setPosts(result.data.posts);
        setTotalPages(result.data.totalPages);
      }
    }
    loadPosts();
  }, [selectedCategory, page]);

  const handleCategoryClick = (slug) => {
    setSelectedCategory(slug);
    setPage(1);
  };

  const handleDownload = async (post) => {
    setDownloadingId(post.id);
    const result = await downloadBlogFile(post.id, post.file_name);
    setDownloadingId(null);

    if (!result.success) {
      setModal({ show: true, message: result.message });
    }
  };

  return (
    <div dir="rtl" id="blogid" style={{ padding: '40px 16px', backgroundColor: '#1c2529' }}>
      <h1 className="w3-text-white w3-center" style={{ fontSize: '36px', marginBottom: 8 }}>
        وبلاگ آموزشی
      </h1>
      <p className="w3-text-light-grey w3-center" style={{ marginBottom: 30, fontSize: 14 }}>
        مطالب آموزشی تخصصی در زمینه تعمیرات و الکترونیک — روی هر مقاله کلیک کنید تا فایل آن دانلود شود
      </p>

      {/* تب‌های دسته‌بندی */}
      <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: 8, marginBottom: 30 }}>
        <button
          onClick={() => handleCategoryClick('')}
          className="w3-button w3-round-xxlarge"
          style={{
            backgroundColor: selectedCategory === '' ? '#2980b9' : 'transparent',
            color: 'white',
            border: '1.5px solid #2980b9',
            padding: '6px 16px',
            fontSize: 13
          }}
        >
          همه مطالب
        </button>
        {categories.map((cat) => (
          <button
            key={cat.id}
            onClick={() => handleCategoryClick(cat.slug)}
            className="w3-button w3-round-xxlarge"
            style={{
              backgroundColor: selectedCategory === cat.slug ? '#2980b9' : 'transparent',
              color: 'white',
              border: '1.5px solid #2980b9',
              padding: '6px 16px',
              fontSize: 13
            }}
          >
            {cat.name}
          </button>
        ))}
      </div>

      {/* لیست مقالات - ۶ تا در هر ردیف روی دسکتاپ */}
      {loading ? (
        <p className="w3-text-white w3-center">در حال بارگذاری...</p>
      ) : posts.length === 0 ? (
        <p className="w3-text-grey w3-center" style={{ padding: 40 }}>مقاله‌ای برای نمایش وجود ندارد.</p>
      ) : (
        <div className="w3-row-padding">
          {posts.map((post) => (
            <div key={post.id} className="w3-col l2 m4 s6" style={{ marginBottom: 16, padding: '0 6px' }}>
              <div
                className="w3-card-4 w3-round-large w3-hover-shadow"
                style={{ backgroundColor: '#263238', overflow: 'hidden', height: '100%', display: 'flex', flexDirection: 'column' }}
              >
                <div
                  style={{
                    width: '100%',
                    height: 0,
                    backgroundColor: '#1c2529',
                    backgroundImage: post.cover_image ? `url(${getCoverImageUrl(post.cover_image)})` : 'none',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                >
                  {!post.cover_image && (
                    <i className="material-icons" style={{ fontSize: 30, color: '#37474F' }}>article</i>
                  )}
                </div>

                <div className="w3-container" style={{ flex: 1, display: 'flex', flexDirection: 'column', padding: '8px 10px' }}>
                  <span
                    className="w3-round"
                    style={{
                      backgroundColor: '#2980b933',
                      color: '#4FC3F7',
                      fontSize: 9,
                      padding: '2px 7px',
                      alignSelf: 'flex-start',
                      marginBottom: 6,
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      maxWidth: '100%'
                    }}
                  >
                    {post.category_name}
                  </span>

                  <h5
                    onClick={() => handleDownload(post)}
                    className="w3-text-white"
                    style={{
                      margin: 0,
                      marginBottom: 6,
                      fontSize: 13,
                      minHeight: 34,
                      lineHeight: '17px',
                      cursor: 'pointer',
                      display: '-webkit-box',
                      WebkitLineClamp: 2,
                      WebkitBoxOrient: 'vertical',
                      overflow: 'hidden'
                    }}
                  >
                    {post.title}
                  </h5>

                  <div style={{ flex: 1 }}></div>

                  {/* نوار دانلود جمع‌وجور */}
                  <div
                    onClick={() => handleDownload(post)}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      backgroundColor: '#1c2529',
                      borderRadius: 8,
                      padding: '6px 8px',
                      marginTop: 6,
                      cursor: 'pointer',
                      border: '1px solid #37474F'
                    }}
                  >
                    <div style={{ display: 'flex', alignItems: 'center', gap: 5, minWidth: 0 }}>
                      <i className="material-icons" style={{ color: '#4FC3F7', fontSize: 16, flexShrink: 0 }}>
                        {getFileIcon(post.file_name)}
                      </i>
                      <div style={{ minWidth: 0 }}>
                        <div className="w3-text-white" style={{ fontSize: 10, whiteSpace: 'nowrap' }}>
                          {downloadingId === post.id ? 'در حال دانلود...' : 'دانلود'}
                        </div>
                        <div className="w3-text-grey" style={{ fontSize: 9 }}>
                          {formatFileSize(post.file_size)}
                        </div>
                      </div>
                    </div>
                    <i className="material-icons" style={{ color: '#15ff00', fontSize: 15, flexShrink: 0 }}>download</i>
                  </div>

                  <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 9, marginTop: 6 }} className="w3-text-grey">
                    <span>{formatDate(post.created_at)}</span>
                    <span style={{ display: 'flex', alignItems: 'center' }}>
                      <i className="material-icons" style={{ fontSize: 11, marginLeft: 2 }}>download_done</i>
                      {post.views}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* صفحه‌بندی */}
      {totalPages > 1 && (
        <div style={{ display: 'flex', justifyContent: 'center', gap: 6, marginTop: 20 }}>
          {Array.from({ length: totalPages }, (_, i) => i + 1).map((p) => (
            <button
              key={p}
              onClick={() => setPage(p)}
              className="w3-button w3-round"
              style={{
                minWidth: 32,
                backgroundColor: p === page ? '#2980b9' : 'transparent',
                color: 'white',
                border: '1px solid #37474F',
                fontSize: 13
              }}
            >
              {p}
            </button>
          ))}
        </div>
      )}

      {modal.show && (
        <div className="w3-modal" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 999 }}>
          <div
            className="w3-card-4 w3-animate-zoom"
            style={{ backgroundColor: '#263238', borderTopLeftRadius: '20px', borderBottomRightRadius: '20px', maxWidth: '320px', width: '90%', direction: 'rtl', overflow: 'hidden' }}
          >
            <div className="w3-container w3-padding" style={{ backgroundColor: '#ff000022', borderBottom: '2px solid #ff0000' }}>
              <span onClick={() => setModal({ show: false, message: '' })} className="w3-button w3-display-topright" style={{ color: 'white' }}>&times;</span>
              <h4 className="w3-text-white" style={{ margin: 0 }}>❌ خطا</h4>
            </div>
            <div className="w3-container w3-padding"><p className="w3-text-white">{modal.message}</p></div>
            <div className="w3-container w3-padding" style={{ paddingBottom: '15px' }}>
              <button
                onClick={() => setModal({ show: false, message: '' })}
                className="w3-button w3-block"
                style={{ color: '#ff0000', backgroundColor: 'transparent', border: '2px solid #ff0000', borderRadius: '10px' }}
              >
                باشه
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};